const sealRepository = (fetch: CustomFetch) => ({
  async getSealImage(businessId: string, accountName: string) {
    return fetch<Blob>(`/v1/businesses/${businessId}/seals/${accountName}/image`)
  },
})

export default sealRepository
